import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser"

const TripleIconSection = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { title, textArray, iconArray } = props

    if (isMobile)
        return (
            <section className="flex  w100 white-bkg">
                <section className="flex col gap-10 jcenter pad-30  main-middle-section-2 triple-icon-section">

                    <h2 className="middle-section-title">{title}</h2>

                    {
                        textArray?.map((text, index) => {
                            return (
                                <article key={index} className="flex">{parse(text)}</article>
                            )
                        })
                    }


                    <section className="flex col gap-10 triple-icon-row">
                        {
                            iconArray?.map((icon, index) => {
                                return (
                                    <article key={index} className="flex col acenter gap-10 ">
                                        <i className={icon.name}></i>
                                        <article className="flex w100">{parse(icon.text)}</article>
                                    </article>
                                )
                            })
                        }
                    </section>

                </section>
            </section>
        )
    else
        return (
            <section className="flex w100 col white-bkg">
                <section className="flex col jcenter pad-30  main-middle-section-2 triple-icon-section">
                    <h2 className="middle-section-title">{title}</h2>

                    {
                        textArray.map((text, index) => {
                            return (
                                <article key={index}>{parse(text)}</article>
                            )
                        })
                    }

                </section>
                <section className="flex jcenter gap-20 pad-20 main-middle-section-2 triple-icon-section sbetween triple-icon-row">

                    {
                        iconArray.map((icon, index) => {
                            return (
                                <article key={index} className="flex col acenter gap-10 w-30">
                                    <i className={icon.name}></i>
                                    {parse(icon.text)}
                                </article>
                            )
                        })
                    }

                </section>
            </section>
        )

}

export default TripleIconSection